var modelstate = false;

jQuery( ".gallery-exit" ).click(function() {
    exit();
});	

jQuery(document).on('keyup', function(e) {
    if (e.key == "Escape") {
        exit();
    };
  });

function exit(){
    jQuery(".fullscreen-overlay").hide();
    jQuery('.modal-open-noscroll').removeClass('modal-open-noscroll');
    modelstate = false;
}

document.addEventListener('click', function(e) {
    var el = e.target.closest('.closeme');
    if (el) {
        //console.log('click inside the popup');
    } else {
        //console.log('click outsite the popup');
        if (modelstate){
            exit();
        }
        
    }
});


var margin = 0;

function scrollstick(){

    page_width = jQuery( window ).width();
    //console.log("page_width :" + page_width);

    var scroll = jQuery(window).scrollTop();
    //console.log("scroll: " + scroll);

    var height = jQuery('.product_info_container').height();
    var height_outer = jQuery('.product_info_container_outer').height(); 
    var width_outer = jQuery('.product_info_container_outer').width(); 
    var movable_distance = height_outer - height;

    // if(page_width >= 768){

    // }else{
    // 	margin == 0;
    // }

    var pro_info_box = jQuery('.product_info_container');

    if(page_width >= 980){
        
        if (scroll >= movable_distance){
            pro_info_box.css('position', 'unset');
        } else {
            pro_info_box.css('position', 'fixed');
            pro_info_box.css('width', width_outer + "px");

        }
    }else{
        pro_info_box.css('position', 'unset');
        pro_info_box.css('width', "100%");
    }
    //pro_info_box.css('margin-top', (margin + 'px'));

    //console.log("movable_distance: " + movable_distance +  " height: " + height + " height_outer: " + height_outer );

    // var selected_name = jQuery('.woo-selected-variation-item-name');

    

    // selected_name.each(function() {
    // 	var text = jQuery( this ).text();
    // 	if (text.startsWith(":")){
    // 		text = text.replace(": ", "");
    // 		jQuery( this ).text(text);
    // 	}
    // });
    
    //if (selected_name.startsWith(":")){
        //selected_name = selected_name.replace(": ", "");
        //jQuery('.woo-selected-variation-item-name').text(selected_name);
    //}
}

const interval = setInterval(function() {
    scrollstick();
}, 1);

jQuery( document ).ready(function() {
console.log( "ready!" );

var selected_img = "0";
var total_imgs = parseInt(jQuery('.total').data("total"))-1;

var fullscreen_gallery = jQuery('.fullscreen-overlay .display_image');

function update_gallery_image(img_num, transition){

    var imageref = jQuery('.img-' + img_num).data("url");
    console.log("image: " + img_num +  " | url: " +  imageref);
    fullscreen_gallery.attr("src", imageref);

    if (transition == "fade"){
        jQuery('.fullscreen-overlay').fadeIn(250, function () {
            modelstate = true;
        });
        
    }
    
}


jQuery( ".gallery-hover" ).click(function(){

    jQuery('body').addClass('modal-open-noscroll');
    var winheight= jQuery(window).height() + "px";
    jQuery('.modal-open-noscroll').height(winheight);
    img_num = jQuery(this).data("order");
    update_gallery_image(img_num, "fade");


    
    }
);

jQuery( ".gallery-arrow" ).click(function(e){
    console.log("arrow clicked");
    img_num = parseInt(selected_img);

    var direction = jQuery(this).data("direction");
    if (direction == "right"){
        img_num = img_num + 1;
        if(img_num > total_imgs) {
            img_num = 0;
        }
    } else {
        img_num = img_num - 1;
        if(img_num < 0) {
            img_num = total_imgs;
        }
    }
    //console.log("set img_num: " + img_num);
    selected_img = img_num;

    update_gallery_image(img_num, "none");


    e.stopPropagation();

    }
);

jQuery( ".img_selector" ).hover(function(){
    img_num = jQuery(this).data("order");
    selected_img = img_num;
    update_gallery_image(img_num, "none");
    }
);



});


